module.exports = __webpack_public_path__ + "img/spotify.96a319e0.png";